import { apiClient } from "@/services/api";

export default {
  // CSRF & AUTH
  setCSRF() {
    return apiClient.get("/csrf-cookie");
  },
  register(userData) {
    return apiClient.post("/auth/register", userData);
  },
  login(credentials) {
    return apiClient.post("/auth/login", credentials);
  },
  async logout() {
    await this.setCSRF();
    return apiClient.post("/auth/logout");
  },
  generateOTP(data) {
    return apiClient.post("/auth/generate-otp", data);
  }
};
